import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

export interface INotFoundProps {}

const NotFound = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  return (
    <div className={classes.notFoundPageWrapper}>
      <h1 className={classes.text}>{t('PageNotFoundMessage')}</h1>
    </div>
  );
};

export default memo(NotFound);
